import { Controller } from '@hotwired/stimulus'

// Simple dialog wrapper for opening/closing modal content.
export default class extends Controller {
  static targets = ['dialog']

  open() {
    const dialog = this.dialogTarget
    if (dialog.showModal) {
      dialog.showModal()
    } else {
      dialog.setAttribute('open', '')
    }
  }

  close() {
    const dialog = this.dialogTarget
    if (dialog.close) {
      dialog.close()
    } else {
      dialog.removeAttribute('open')
    }
  }
}
